import ChevronLeft from '@mui/icons-material/ChevronLeft';
import { IconButton, Stack, Typography } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useCurrentUser } from '../../../hooks/data/user';
import logo from '../../../public/images/logo.svg';
import UserBlock from '../user-block';
import classes from './main-header.module.css';

function MainHeader(props) {
   const { user, error, isLoading } = useCurrentUser();
   const { type } = props;
   const router = useRouter();

   function handleBack() {
      // return to main dashboard
      router.push('/dashboard');
   }

   return (
      <div className={classes.main}>
         <Stack direction="row" alignItems="center" spacing={2}>
            {/* Back icon */}
            {type === 'templates' || type === 'elements' ? (
               <IconButton size="small" color="primary" onClick={handleBack}>
                  <ChevronLeft />
               </IconButton>
            ) : null}
            <Link href="/dashboard">
               <Image src={logo} alt="logo" width={80} />
            </Link>
            <Typography variant="h6" component="h1">
               {type ? type.toUpperCase() : null}
            </Typography>
         </Stack>
         {user && <UserBlock />}

         {!user && (
            <div className={classes.guest}>
               <div className={classes.login}>Login</div>
               <div className={classes.signup}>Signup</div>
            </div>
         )}
      </div>
   );
}

export default MainHeader;
